module.exports = __webpack_public_path__ + "img/selected0-min.901d05f3.png";